import { TimeSlot } from './stations'

const toMinutes = (time: string): number => {
  const [hours = '0', minutes = '0'] = time.split(':')
  const parsedHours = Number(hours)
  const parsedMinutes = Number(minutes)

  if (Number.isNaN(parsedHours) || Number.isNaN(parsedMinutes)) {
    return Number.MAX_SAFE_INTEGER
  }

  return parsedHours * 60 + parsedMinutes
}

const SIX_AM_IN_MINUTES = 6 * 60

// 当日の受取時間スロット表示用（06:00起点）
export const sortTimeSlotsAscending = (timeSlots: TimeSlot[]): TimeSlot[] => {
  const sorted = [...timeSlots].sort(
    (a, b) => toMinutes(a.from) - toMinutes(b.from)
  )

  const startingIndex = sorted.findIndex(
    timeSlot => toMinutes(timeSlot.from) >= SIX_AM_IN_MINUTES
  )

  if (startingIndex <= 0) {
    return sorted
  }

  return [...sorted.slice(startingIndex), ...sorted.slice(0, startingIndex)]
}

// プリセット編集モーダル用（00:00起点）
export const sortTimeSlotsFromMidnight = (timeSlots: TimeSlot[]): TimeSlot[] => {
  return [...timeSlots].sort(
    (a, b) => toMinutes(a.from) - toMinutes(b.from)
  )
}
